import { render, staticRenderFns } from "./LinkTenantSettingConfirm.vue?vue&type=template&id=79edb484&scoped=true&"
import script from "./LinkTenantSettingConfirm.vue?vue&type=script&lang=js&"
export * from "./LinkTenantSettingConfirm.vue?vue&type=script&lang=js&"
import style0 from "./LinkTenantSettingConfirm.vue?vue&type=style&index=0&id=79edb484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79edb484",
  null
  
)

export default component.exports